import {
  TypeAssignmentStrategy,
  TypePhonesStrategy,
  TypeCoverageStrategy,
  TypeDestinationStrategy,
} from "@/@types/strategies/modalStrategy";

const TYPES_ASSIGNMENT = {
  [TypeAssignmentStrategy.Aleatory]: "Aleatorio",
  [TypeAssignmentStrategy.ByAssignment]: "Por asignación",
};

const TYPES_PHONES = {
  [TypePhonesStrategy.Landline]: "Fijo",
  [TypePhonesStrategy.Movil]: "Movil",
  [TypePhonesStrategy.Both]: "Ambos",
};

const TYPES_CONTACT = {
  [TypeCoverageStrategy.Coverage]: "Contactos gestionados",
  [TypeCoverageStrategy.UnCoverage]: "Contactos sin gestionar",
};

const TYPES_DESTINATION = {
  [TypeDestinationStrategy.Existings]: "Contactos existentes",
  [TypeDestinationStrategy.External]: "Números externos",
};

const FILTERS_STRATEGY = {
  firstSection: {
    title: "Histórico de teléfonos gestionados",
    filters_keys: ["positive_phones"],
    filters: {
      positive_phones: {
        values: {
          1: "Todos los teléfonos del contacto",
          2: "Solo teléfonos con Contacto Directo",
        },
      },
    },
  },
  secondSection: {
    title: "Mejos tipificación",
    filters_keys: ["groups"],
    filters: {
      groups: {
        label: "Grupos",
        key: "name",
      },
      results: {
        label: "Resultado",
        key: "name",
      },
      motives: {
        label: "Motivos",
        key: "name",
      },
      submotives: {
        label: "Submotivos",
        key: "name",
      },
    },
  },
  thirdSection: {
    title: "Usuarios asignados",
    filters_keys: ["agents"],
    filters: { agents: { key: "full_name" } },
  },
  fourSection: {
    title: "Fecha de última gestión de los contactos",
    filters_keys: ["management_date"],
    filters: { management_date: {} },
  },
  fiveSection: {
    title: "Fechas de Promesas de pago",
    filters_keys: ["pdp_date"],
    filters: { pdp_date: {} },
  },
};

enum StrategySpeed {
  Low = 1,
  Medium = 3,
  High = 5,
}

const StrategySpeedText = {
  [StrategySpeed.Low]: "Bajo",
  [StrategySpeed.Medium]: "Medio",
  [StrategySpeed.High]: "Alto",
};

const StrategySpeedDescription = {
  [StrategySpeed.Low]: "Velocidad baja para un barrido de base más controlado y pausado.",
  [StrategySpeed.Medium]: "Velocidad media para un barrido de base equilibrado entre control y alcance.",
  [StrategySpeed.High]: "Velocidad alta para un barrido de base en menor tiempo.",
}

export { TYPES_ASSIGNMENT, TYPES_PHONES, FILTERS_STRATEGY, TYPES_CONTACT, TYPES_DESTINATION, 
  StrategySpeed, StrategySpeedText, StrategySpeedDescription };

export enum StrategyTTSGenerationStatus {
  Pending = "pending",
  Generating = "generating",
  Ready = "ready",
  Expired = "expired",
  Failed = "failed",
}

export const StrategyTTSGenerationStatusText = {
  [StrategyTTSGenerationStatus.Pending]: "Pendiente",
  [StrategyTTSGenerationStatus.Generating]: "Generando",
  [StrategyTTSGenerationStatus.Ready]: "Listo",
  [StrategyTTSGenerationStatus.Expired]: "Expirado",
  [StrategyTTSGenerationStatus.Failed]: "Falló",
};

export enum StrategyTTSStartMode {
  Manual = 1,
  Automatic = 2,
}